// extracted by mini-css-extract-plugin
module.exports = {"main":"main-header_main__hFAsm","nav":"main-header_nav__y_DLY","guest":"main-header_guest__D6YL5"};